const tokenStorage = () => {
  const accessKey = "access-token";

  const getTokens = () => {
    const accessToken = localStorage.getItem(accessKey);

    return { accessToken };
  };
  const setTokens = ({ accessToken }: { accessToken?: string }) => {
    accessToken && localStorage.setItem(accessKey, accessToken);
  };
  const removeTokens = () => {
    localStorage.removeItem(accessKey);
  };

  return { getTokens, setTokens, removeTokens };
};

export { tokenStorage };
